import React from 'react';
import { Alert, AlertColor, Breakpoint, Grid } from '@mui/material';

interface AlertComponentProps {
    type?: AlertColor;
    message: string;
    detailed?: boolean;
    maxWidth?: false | Breakpoint | undefined;
}

export const AlertComponent: React.FC<AlertComponentProps> = ({ message, type = 'info', detailed = false }) => {
    if (detailed) {
        return (
            <Grid my={4}>
                <Alert severity={type}>{message}</Alert>
            </Grid>
        );
    }
    return <Alert severity={type}>{message}</Alert>;
};
